import OlMap from '@m1/ol-map';
import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import { useRef } from 'react';
import { useSelector, useStore } from 'react-redux';

import EventEmitter from '@/libs/EventEmitter';

const useTracer = () => {
  const store = useStore();
  const prevPositions = useRef(new Map());
  const robotOptions = useSelector((state) => state.robotOptions);

  useMountEffect(() => {
    const token = EventEmitter.subscribe('position/update', ({ robotId, position }) => {
      const { lat, lng } = position;

      // 현재 위치와 이전 위치가 같지 않은 경우에만 업데이트
      const prevPosition = prevPositions.current.get(robotId);
      if (prevPosition && prevPosition.lat === lat && prevPosition.lng === lng) return;

      const traceType = store.getState().robotOptions[robotId].trace.type;
      OlMap.trace.add(robotId, { lat, lng }, traceType);

      prevPositions.current.set(robotId, { lat, lng });
    });

    return () => {
      EventEmitter.unsubscribe(token);
    };
  });

  useUpdateEffect(() => {
    Object.entries(robotOptions).forEach(([robotId, { trace }]) => {
      OlMap.trace.setType(robotId, trace.type);
      OlMap.trace.setVisible(robotId, trace.visible);
    });
  }, [robotOptions]);
};

export default useTracer;
